import React from 'react';

import Button from '../Button';

const LargeButton = (props) => <Button type='large' {...props} />;

export default LargeButton;